import { render, staticRenderFns } from "./DisplayCard.vue?vue&type=template&id=102e68a6&scoped=true&"
import script from "./DisplayCard.vue?vue&type=script&lang=js&"
export * from "./DisplayCard.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCard.vue?vue&type=style&index=0&id=102e68a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102e68a6",
  null
  
)

export default component.exports